const KOREA_UTC_OFFSET_MS = 9 * 60 * 60 * 1000;
const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;
const TIME_PATTERN = /^(\d{1,2}):(\d{2})$/;
const UPCOMING_RESERVATION_STATUSES = new Set(['request', 'confirmed']);

export function getReservationDateTimeTimestamp(date, time) {
  const normalizedDate = date instanceof Date && Number.isFinite(date.getTime())
    ? date.toISOString()
    : String(date || "").trim();
  const dateMatch = normalizedDate.match(DATE_PATTERN);
  const timeMatch = String(time || "").trim().match(TIME_PATTERN);
  if (!dateMatch || !timeMatch) return NaN;

  const year = Number(dateMatch[1]);
  const month = Number(dateMatch[2]);
  const day = Number(dateMatch[3]);
  const hour = Number(timeMatch[1]);
  const minute = Number(timeMatch[2]);

  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return NaN;

  const dateOnlyTimestamp = Date.UTC(year, month - 1, day);
  const parsedDate = new Date(dateOnlyTimestamp);
  if (
    parsedDate.getUTCFullYear() !== year
    || parsedDate.getUTCMonth() !== month - 1
    || parsedDate.getUTCDate() !== day
  ) {
    return NaN;
  }

  return Date.UTC(year, month - 1, day, hour, minute) - KOREA_UTC_OFFSET_MS;
}

export function isValidReservationDateTime(date, time) {
  return Number.isFinite(getReservationDateTimeTimestamp(date, time));
}

export function isFutureReservationDateTime(date, time, now = new Date()) {
  const reservationTimestamp = getReservationDateTimeTimestamp(date, time);
  const currentTimestamp = new Date(now).getTime();

  return Number.isFinite(reservationTimestamp)
    && Number.isFinite(currentTimestamp)
    && reservationTimestamp > currentTimestamp;
}

export function isPastOrCurrentReservationDateTime(date, time, now = new Date()) {
  const reservationTimestamp = getReservationDateTimeTimestamp(date, time);
  const currentTimestamp = new Date(now).getTime();

  return Number.isFinite(reservationTimestamp)
    && Number.isFinite(currentTimestamp)
    && reservationTimestamp <= currentTimestamp;
}

export function isUpcomingReservation(reservation, now = new Date()) {
  const status = reservation && reservation.status;
  const date = reservation && reservation.date;
  const time = reservation && reservation.time;

  return UPCOMING_RESERVATION_STATUSES.has(status)
    && isFutureReservationDateTime(date, time, now);
}
